<template>
    <div class="page-rank">
        <van-tabs v-model="active" type="card" class="my-tabs" @click="clickTab">
            <van-tab title="金币收益榜">
                <gold-rank></gold-rank>
            </van-tab>
            <van-tab title="战绩榜">
                <bat-rank></bat-rank>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
    import GoldRank from './mod/gold-rank'
    import BatRank from './mod/bat-rank'
    export default {
        data() {
            return {
                active: +this.$route.query.index || 0
            }
        },
        components:{
            'gold-rank' : GoldRank,
            'bat-rank' : BatRank
        },
        methods : {
            clickTab(){
                this.$router.push({
                    name :'ranking',
                    query : { index : this.active }
                })
            }
        },
        created() {
            console.log(this.$route.query.index)
        }
    }
</script>